import React, { useState } from 'react'
import PedidosYaStyle from '../../../../../assets/css/components/admin/plugins/PedidosYaStyle';
import Navbar from './Navbar';
import Campaign from './Campaign';
import CampaignList from './CampaignList';

export default function CasheaCampaign() {
    const [currentStep, setCurrentStep] = useState(0);
    const [hasVisitedList, setHasVisitedList] = useState(false);
    const [listRefreshKey, setListRefreshKey] = useState(0);

    const changeStep = (step) => {
        if (step === 1) {
            setHasVisitedList(true);
            setListRefreshKey((prev) => prev + 1);
        }

        setCurrentStep(step);
    };

    return (
        <PedidosYaStyle.Cont>
            <PedidosYaStyle.Header>
                <PedidosYaStyle.Text size="15pt" fw="500">
                    Campañas de Cashea
                </PedidosYaStyle.Text>
            </PedidosYaStyle.Header>
            <Navbar currentStep={currentStep} setCurrentStep={changeStep} />
            <PedidosYaStyle.ContStep>
                <div style={{ display: currentStep === 0 ? 'block' : 'none' }}>
                    <Campaign />
                </div>
                {(hasVisitedList || currentStep === 1) && (
                    <div style={{ display: currentStep === 1 ? 'block' : 'none' }}>
                        <CampaignList refreshKey={listRefreshKey} />
                    </div>
                )}
            </PedidosYaStyle.ContStep>
        </PedidosYaStyle.Cont>
    )
}